import React, { memo, useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ProgressBar from '../ProgressBar/ProgressBar';

import './ConsumptionPlan.css';

function ConsumptionPlan() {
  const [progressBarValues, setProgressBarValues] = useState([
    { count: 0, title: '', color: '#ffffff' },
  ]);

  const planConsumption = useSelector((state) => state.plans.planConsumption);
  const company = useSelector((state) => state.companies.company);

  const { plan } = company;

  useEffect(() => {
    if (plan?.name?.toLowerCase() === 'freemium') {
      setProgressBarValues([
        {
          count: planConsumption?.webchatConsumption || 0,
          title: 'Webchat',
          color: '#FFAA00',
        },
        // {
        //   count: planConsumption?.messengerConsumption || 0,
        //   title: 'Messenger',
        //   color: '#0A7CFF',
        // },
      ]);
    } else {
      setProgressBarValues([
        {
          count: planConsumption?.whatsappConsumption || 0,
          title: 'Whatsapp',
          color: '#13E676',
        },
      ]);
    }
  }, [company, planConsumption]);

  const maxMessages = useMemo(() => {
    if (plan?.name?.toLowerCase() === 'freemium') {
      // const messengerConsumption =
      //   planConsumption?.messengerConsumption || 0;
      // const webchatConsumption = planConsumption?.webchatConsumption || 0;
      // const totalConsumption =
      //   Number(messengerConsumption) + Number(webchatConsumption);
      // return totalConsumption <= 1000 ? 1000 : totalConsumption;
      const webchatConsumption = planConsumption?.webchatConsumption || 0;
      const totalConsumption = Number(webchatConsumption);
      return totalConsumption <= 1000 ? 1000 : totalConsumption;
    }

    return plan?.amountWhatsappConversation || 0;
  }, [plan, planConsumption]);

  return (
    <div className="plan-container consumption-plan-container">
      <div className="plan-container-title">Consumo por canal</div>
      <ProgressBar values={progressBarValues} max={maxMessages || 0} />
    </div>
  );
}

export default withRouter(memo(ConsumptionPlan));
